import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Nullable, OrdenTrabajoOld } from '@/shared/interfaces';

type OTInstalacionStore = Nullable<OrdenTrabajoOld>;
export interface OrdenTrabajoStore {
  ordenTrabajo: any | null;
  ordenTrabajoInstalacion: OTInstalacionStore;
  isLoadingOT: boolean;
  isRefetchingOT: boolean;

  setOrdenTrabajo: (ordenTrabajo: any) => void;
  clearOrdenTrabajo: () => void;
  setOrdenTrabajoInstalacion: (ordenTrabajo: OTInstalacionStore) => void;
  clearAll: () => void;
  setIsLoadingOT: (isLoadingOT: boolean) => void;
  setIsRefetchingOT: (isRefetchingOT: boolean) => void;
}

export const useOrdenTrabajoStore = create<OrdenTrabajoStore>()(
  persist(
    set => ({
      ordenTrabajo: null,
      ordenTrabajoInstalacion: null,
      isLoadingOT: false,
      isRefetchingOT: false,

      setOrdenTrabajo: ordenTrabajo => set({ ordenTrabajo }),

      clearOrdenTrabajo: () => set({ ordenTrabajo: null }),

      setOrdenTrabajoInstalacion: ordenTrabajoInstalacion =>
        set({ ordenTrabajoInstalacion }),

      clearAll: () =>
        set({ ordenTrabajo: null, ordenTrabajoInstalacion: null }),

      setIsLoadingOT: isLoadingOT => set({ isLoadingOT }),

      setIsRefetchingOT: isRefetchingOT => set({ isRefetchingOT }),
    }),

    {
      name: 'orden-trabajo-tecnico',
    }
  )
);
